import React from 'react'

const ContentWrapper = ({ children }: { children: React.ReactNode }) => (
  <div className='w-full md:flex md:flex-row md:space-x-12 md:justify-center type-default text-default'>
    {children}
  </div>
)

export default ContentWrapper
